import React, { Component } from 'react';
import {connect} from 'react-redux';
import {filterUrl, logData} from '../../utils/utils';
import {testUrl} from '../../actions/getAgentConfig';

class Iframe extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    }
  }

  // gets url that needs to be displayed on input
	getUrl = (url) => {
		return filterUrl(url);
	}

  iframLoad = (e) => {
    // const src = e.target.src;
    // this.setState({
    //   hasError: false
    // }, () => {
    //   this.props.testUrl(src).then((res) => {
    //     this.setState({
    //       hasError: res.data.error || res.data.httpcode !== 200
    //     });
    //   });
    // });
	}

  iframError = () => {
    logData('Error');
  }

	render() {
    const {
      hasError
    } = this.state;
    const {
      item,
      hasId,
      errorMsg
    } = this.props;
		return (
      <div style={{height: '100%', position: 'relative'}}>
        <iframe
          title={item.url}
          id={hasId ? `webpage_iframe${item.url_id}` : ''}
          className={item.type ? "content-pane-cont free-tops iframe_section" : "content-pane-cont free-tops iframe_section omni_iframe"}
          src={this.getUrl(item.url)}
          onLoad={ this.iframLoad }
          onError={ this.iframError }
        />
        {hasError && <h5 style={{position: 'absolute', top: 20, left: 20}}>{errorMsg}</h5>}
      </div>
	  );
	}
}

const mapDispatchToProps = {
  testUrl
};

export default connect(null, mapDispatchToProps)(Iframe);



// WEBPACK FOOTER //
// ./src/agent/Components/Iframe.jsx